import { InjectionToken } from '@angular/core';
import type { ContentConfig } from 'config/interfaces';

export const MONTHLY_STATEMENT_CONTENT_CONFIG = new InjectionToken<ContentConfig>('MONTHLY_STATEMENT_CONTENT_CONFIG');
